




import Vue from "vue";
import OrganizationDelete from "@/components/organizations/organization-delete.component.vue";

export default Vue.extend({
  components: {
    "organization-delete": OrganizationDelete,
  },
});
